import useWindowSize, { Size } from "../../hooks/useWindowSize";
import Drawer from "../General/Drawer";
import Modal from "../General/Modal";
import Input from "../General/Input";
import RadioInput from "../General/RadioInput";
import TextArea from "../General/TextArea";
import Button from "../General/Button";
import { setOrderPayload, submitOrder, states, responseStates } from "../../store/CoreSlice";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import OrderSchema from "../../validations/Order";
import { useEffect } from "react";

function OrderDetails({show, productName, onClose, data} : any) {  
    const initialValues : any = {
        is_order_in_sez : false,
        extra_note : '',
        payment_option : 1,
        buyer_company_name : '',
        phone : data.phone || '',
        email : data.email || '',
        buyer_name : data.buyerName || '',
        shipping_address : '',
        billing_address : ''
    }

    const size : any = useWindowSize();
    const dispatch : any = useDispatch();
    const { orderPayload } = useSelector((state : any) => state.core);

    const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm, setFieldValue } = useFormik({
        initialValues : initialValues,
        validationSchema : OrderSchema,

        onSubmit : (values : any) => {
            const payload = {
                is_order_in_sez : values.is_order_in_sez,
                extra_note : values.extra_note,
                payment_option : values.payment_option,
                buyer_company_name : values.buyer_company_name,
                phone : data.phone || '',
                email : data.email || '',
                buyer_name : data.buyerName || '',
                purchase_price : (data.quantity * data.price).toFixed(2),
                cart_items : [
                    {
                        ...orderPayload.cart_items[0],
                        shipping_address : values.shipping_address,
                        billing_address : values.billing_address
                    }
                ]
            }
            dispatch(setOrderPayload(payload));
            dispatch(submitOrder());
        }
    })

    useEffect(() => {
        setFieldValue('phone', data.phone)
        setFieldValue('email', data.email)
        setFieldValue('buyer_name', data.buyerName)
    }, [data])

    useEffect(() => {
        if(orderPayload.responseStatus === responseStates.SUCCESS) 
            resetForm();
    }, [orderPayload.responseStatus])

    const getComponent = (data : any) => {
        if(size.width < 800)
            return <Modal show = {show} fullScreen > {data} </Modal>
        return <Modal transition="animateup" styles = "w-[50%]" show = {show}> {data} </Modal>
    }    

    const handleClose = () => {
        resetForm();
        onClose();
    }

    return (
        getComponent(
            <div className="h-[80vh] lg:h-[87vh] overflow-y-auto">
                <div className="p-4 lg:px-[30px] lg:pt-[16px]">

                    <div className="flex justify-between items-center">
                        <h4 className="text-[#324D9F] text-[28px]"> {productName} </h4>
                        <svg onClick={handleClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>

                    <div className="py-4 px-4" style={{ background: 'rgba(238, 238, 238, 0.5)' }}>
                        <div className="grid grid-cols-3 text-center" style={{ border : '0.2px solid rgba(0, 0, 0, 0.3)' }}>
                            <span className="border-r py-1">Quantity</span>
                            <span className="border-r py-1">Price</span>
                            {/* <span className="border-r py-1">Tax</span> */}
                            <span className="py-1">Total</span>
                        </div>

                        <div 
                            className="grid grid-cols-3 text-center" 
                            style={{ 
                                border : '0.2px solid rgba(0, 0, 0, 0.3)', 
                                borderTop : 0 
                            }}>
                            <span className="border-r py-1"> {data.quantity} KG</span>
                            <span className="border-r py-1">${data.price}/Kg</span>
                            {/* <span className="border-r py-1">$35</span> */}
                            <span className="py-1">${ (data.quantity * data.price).toFixed(2) } <small> + taxes </small> </span>
                        </div>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="p-4 lg:px-[30px] lg:py-0">
                    <div className="mb-[5px] lg:flex lg:justify-between"> 
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[40%]">Buyer Company Name</label>

                        <div className="lg:w-[58%]">
                            <Input 
                                outerProperties = "border border-[#EDEDED] rounded"
                                properties = "rounded"
                                onChange = {handleChange}
                                value = {values.buyer_company_name}
                                name = 'buyer_company_name'
                                onBlur = {handleBlur}
                                error={errors.buyer_company_name}
                                touched={touched.buyer_company_name}
                            />
                        </div>
                    </div>

                    <div className="mb-[5px] lg:flex lg:items-center lg:justify-between">
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[40%]">Buyer Name</label>

                        <div className="lg:w-[58%]">
                            <Input 
                                outerProperties = "border border-[#EDEDED] rounded"
                                properties = "rounded"
                                onChange = {handleChange}
                                value = {values.buyer_name}
                                name = 'buyer_name'
                                onBlur = {handleBlur}
                                error={errors.buyer_name}
                                touched={touched.buyer_name}
                            />
                        </div>
                    </div>

                    <div className="mb-[5px] lg:flex lg:items-center lg:justify-between">
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[40%]">Phone</label>

                        <div className="lg:w-[58%]">
                            <Input 
                                outerProperties = "border border-[#EDEDED] rounded"
                                properties = "rounded"
                                onChange = {handleChange}
                                value = {values.phone}
                                name = 'phone'
                                onBlur = {handleBlur}
                                error={errors.phone}
                                touched={touched.phone}
                            />
                        </div>
                    </div>

                    <div className="mb-[5px] lg:flex lg:items-center lg:justify-between">
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[40%]">Email</label>

                        <div className="lg:w-[58%]">
                            <Input 
                                outerProperties = "border border-[#EDEDED] rounded"
                                properties = "rounded"
                                onChange = {handleChange}
                                value = {values.email}
                                name = 'email'
                                onBlur = {handleBlur}
                                error={errors.email}
                                touched={touched.email}
                            />
                        </div>
                    </div>

                    <div className="mb-[5px] lg:flex lg:items-center lg:justify-between">
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[40%]">Shipping Address</label>

                        <div className="lg:w-[58%]">
                            <Input 
                                outerProperties = "border border-[#EDEDED] rounded"
                                properties = "rounded"
                                onChange = {handleChange}
                                value = {values.shipping_address}
                                name = 'shipping_address'
                                onBlur = {handleBlur}
                                error={errors.shipping_address}
                                touched={touched.shipping_address}
                            />
                        </div>
                    </div>

                    <div className="mb-[5px] lg:flex lg:items-center lg:justify-between">
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[40%]">Billing Address</label>

                        <div className="lg:w-[58%]">
                            <Input 
                                outerProperties = "border border-[#EDEDED] rounded"
                                properties = "rounded"
                                onChange = {handleChange}
                                value = {values.billing_address}
                                name = 'billing_address'
                                onBlur = {handleBlur}
                                error={errors.billing_address}
                                touched={touched.billing_address}
                            />
                        </div>
                    </div>

                    <div className="mb-[5px] lg:flex lg:items-center lg:justify-between">
                        <label className="inline-block mb-2 lg:mb-0 text-[15px] font-light lg:w-[40%]">Are you in SEZ? (only if shipping address is in India)</label>

                        <div className="flex mt-3 lg:mt-0 lg:w-[58%]">
                            <div className="mr-3">
                                <RadioInput 
                                    uniqueID = "sez__yes"
                                    name = "is_sez"
                                    label = "Yes"
                                    labelProperties = "text-[15px]"
                                    onChange = {() => setFieldValue('is_order_in_sez', true)}
                                />
                            </div>

                            <RadioInput 
                                uniqueID = "sez__no"
                                name = "is_sez"
                                label = "No"
                                labelProperties = "text-[15px]"
                                checked
                                onChange = {() => setFieldValue('is_order_in_sez', false)}
                            />
                        </div>
                    </div>

                    <div style={{ background: 'rgba(238, 238, 238, 0.5)' }} className="mt-[15px] px-2 py-4 rounded lg:flex lg:justify-between">
                        <label className="inline-block mb-2 text-[15px] font-light lg:w-[30%]">Payment Option</label>

                        <div className="flex mt-3 lg:mt-0 flex-wrap lg:w-[64%]">
                            <div className="mr-3 mb-2">
                                <RadioInput 
                                    uniqueID = "payment_options__LC"
                                    name = "payment_options"
                                    label = "LC"
                                    labelProperties = "text-[15px]"
                                    checked
                                    value = {1}
                                    onChange = {(event : any) => setFieldValue('payment_option', event.target.value)}
                                />
                            </div>

                            <div className="mr-3">
                                <RadioInput 
                                    uniqueID = "payment_options__PDC"
                                    name = "payment_options"
                                    label = "PDC"
                                    labelProperties = "text-[15px]"
                                    value = {2}
                                    onChange = {(event : any) => setFieldValue('payment_option', event.target.value)}
                                />
                            </div>

                            {/* <div className="mr-3">
                                <RadioInput 
                                    uniqueID = "payment_options__online"
                                    name = "payment_options"
                                    label = "Online"
                                    labelProperties = "text-[15px]"
                                    value = {3}
                                    onChange = {(event : any) => setFieldValue('payment_option', event.target.value)}
                                />
                            </div> */}

                            {/* <div>
                                <RadioInput 
                                    uniqueID = "payment_options__apidrug"
                                    name = "payment_options"
                                    label = "APIdrug Credit"
                                    labelProperties = "text-[15px]"
                                    value = {4}
                                    onChange = {(event : any) => setFieldValue('payment_option', event.target.value)}
                                />
                            </div> */}

                            <div>
                                <RadioInput 
                                    uniqueID = "payment_options__wireless_transfer"
                                    name = "payment_options"
                                    label = "Wire Transfer"
                                    labelProperties = "text-[15px]"
                                    value = {5}
                                    onChange = {(event : any) => setFieldValue('payment_option', event.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <TextArea 
                        outerProperties = "border rounded mt-[16px]"
                        properties = "rounded"
                        onChange = {handleChange}
                        value = {values.extra_note}
                        name = 'extra_note'
                        onBlur = {handleBlur}
                        error={errors.extra_note}
                        touched={touched.extra_note}
                    />

                    <Button 
                        type = "submit" 
                        styles = "bg-theme-orange text-white mt-5 ml-auto" 
                        height = {38} 
                        width = {120}
                        loader = {orderPayload.status === states.IN_PROGRESS}
                    > 
                        Next 
                    </Button>
                </form>
            </div>
        )
    )
}

export default OrderDetails